import { JSX } from 'react';
import { Box } from '@mui/material';
import { useSelector } from 'react-redux';
import OnBehalfOfBanner from 'src/components/NewRenterInterface/shared/OnBehalfOfBanner';
import { useOnBehalfOf } from 'src/hooks/useOnBehalfOf';
import type { InterviewState } from 'src/redux/slices/Interview/types';
import InterviewHeader from './InterviewHeader';
import InterviewBody from './InterviewBody';
import {
  InterviewOverlayProvider,
  useInterviewOverlay,
} from './InterviewOverlayContext';

export default function InterviewShell(): JSX.Element {
  return (
    <InterviewOverlayProvider>
      <InterviewShellInner />
    </InterviewOverlayProvider>
  );
}

function InterviewShellInner(): JSX.Element {
  const { onBehalfOf, certId } = useSelector(
    (state: { interview: InterviewState }) => state.interview
  );
  const { subjectName } = useOnBehalfOf({ subjectUserId: onBehalfOf, certId });
  const { contentRef } = useInterviewOverlay();

  return (
    <Box
      sx={{
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        bgcolor: { xs: 'background.default', md: 'background.neutral' },
      }}
    >
      <InterviewHeader />
      <OnBehalfOfBanner name={subjectName} />
      <Box
        ref={contentRef}
        sx={{
          flex: 1,
          minHeight: 0,
          display: 'flex',
          flexDirection: 'column',
          position: 'relative',
        }}
      >
        <InterviewBody />
      </Box>
    </Box>
  );
}
